import { Component, Input, OnInit } from '@angular/core';
import { ListAbstract } from 'app/views/pages/abstract/list-abstract';
import { OdataEntityField } from 'services/models/odata/odataEntityField';
import { ActionPlanTypeService } from 'services/corporate/action-plan/action-plan-type.service';
import { ActionPlanTypeModel } from 'services/models/corporate/action-plan/action-plan-type.model';
import { ActionPlanTypeManageDrawerComponent } from '../action-plan-type-manage-drawer/action-plan-type-manage-drawer.component';
import { Filter } from 'services/models/odata/filter';

const defaultLoadingStates = {
  datatable: true,
};

const defaultCurrentSort = {
  prop: 'title' as string,
  dir: 'asc' as any,
};

@Component({
  selector: 'app-action-plan-type-datatable',
  templateUrl: './action-plan-type-datatable.component.html',
  styleUrls: ['./action-plan-type-datatable.component.scss'],
})
export class ActionPlanTypeDatatableComponent
  extends ListAbstract<ActionPlanTypeModel, ActionPlanTypeService>
  implements OnInit
{
  @Input() source: string;
  @Input() description: string;
  title: string;

  fields = [{ field: 'title', alias: 'Tipo de ação' }].map(x => x as OdataEntityField);

  public currentSort: typeof defaultCurrentSort = defaultCurrentSort;
  public loadingStates: typeof defaultLoadingStates = defaultLoadingStates;
  protected disabledLoading = true;

  constructor(public service: ActionPlanTypeService) {
    super(service);

    this.queryParams.select = ['*'];
    this.queryParams.orderBy = defaultCurrentSort.prop;
    this.queryParams.orderByOrder = defaultCurrentSort.dir;
  }

  ngOnInit(): void {
    this.executeQuery();
  }

  public handleCreateOrUpdate(item?: ActionPlanTypeModel) {
    const _modalRef = this._modalService.open(ActionPlanTypeManageDrawerComponent, {
      animation: false,
    });

    _modalRef.componentInstance.item = item;
    _modalRef.componentInstance.source = this.source;

    _modalRef.result.then(response => {
      if (response?.onRefetch) {
        this.executeQuery();
      }
    });
  }

  public onPage(event: any) {
    this.queryParams.skip = event.offset * event.limit;
    this.queryParams.top = event.limit;

    this.executeQuery();
  }

  public onSort(event: any) {
    if (event && event.sorts && event.sorts.length > 0) {
      const [sort] = event.sorts;

      const dir = sort.dir === 'desc' ? 'desc' : 'asc';

      this.currentSort = { prop: sort.prop, dir };
      this.queryParams.orderBy = `${sort.prop}`;
      this.queryParams.orderByOrder = dir;

      this.executeQuery();
    }
  }

  async executeQuery(_event?: any) {
    this.queryParams.filter = Filter.equal('source', this.source);

    this._setLoadingState('datatable', true);

    this.service
      .customList<ActionPlanTypeModel>(this.queryParams, 'list', ActionPlanTypeModel, true)
      .subscribe({
        next: response => {
          this.list = response?.data || [];
          this.count = Number(response?.count || 0);

          this._setLoadingState('datatable', false);
        },
        error: error => {
          console.error('Erro ao carregar lista de tipos de ação do plano de ação:', error);

          this.list = [];
          this.count = 0;

          this._setLoadingState('datatable', false);
        },
      });
  }

  private _setLoadingState(key: keyof typeof defaultLoadingStates, state: boolean) {
    this.loadingStates[key] = state;
  }
}
